import angular from 'angular';
import customerIntegrationsService from './customerIntegrations.service';

let customerIntegrationsModule = angular.module('customerIntegrations', []).service('customerIntegrationsService', customerIntegrationsService);

export default customerIntegrationsModule;



// WEBPACK FOOTER //
// ./app/common/customerIntegrations/customerIntegrations.js